import qs from 'qs'

export const parse = (s: string, options: qs.IParseOptions = { ignoreQueryPrefix: true }) => {
  return qs.parse(s, options)
}



// WEBPACK FOOTER //
// ./src/helpers/url.ts